import { observable, action, computed } from 'mobx'
import { SportItemMap, Market, BetTypeGroup, BetTypeSummaryMap, LeftMenuHeaderGroup, ESportItemMap, TournamentMap, EsportMarket, SportMarketMap, SportGroup, OUTRIGHT_TYPE } from '../common/Foundation';
import _ from 'lodash';
import Constants from '../common/Constants';
import LeftMenuAction from '../components/LeftMenuComponent/LeftMenuAction';
import Utils from '../common/Utils';


export default class SportsMenuStore {

  @observable currentSideBar = Constants.SIDE_BAR_NAME.CLOSE;

  @observable sportsMarketsData = {};

  @observable totalGroups = {};

  @observable leftMenuOptions = {};

  @observable expandId = 0;

  @observable expandEsportCode;

  @observable rightItemExpandId = 0;

  @observable leftMenuHeaderGroup = LeftMenuHeaderGroup.SPORTS;

  @observable historyLeagueIds = {};

  @observable teasersData = {
    isExpand: false,
    items: []
  }

  @action expandTeasers(isExpand) {
    this.teasersData.isExpand = isExpand
  }

  @action addHistoryLeagueIds(url, leagueIds) {
    this.historyLeagueIds[url] = leagueIds;
  }

  @action setHistoryLeagueIds(historyLeagueIds) {
    this.historyLeagueIds = historyLeagueIds;
  }

  @action resetLeftMenuOptions(supportProduct) {
    this.historyLeagueIds = {};
    this.leftMenuOptions = {};
    this.expandId = 0;
    this.expandEsportCode = '';
    this.leftMenuHeaderGroup = this.getLeftMenuHeaderGroupDefault(supportProduct);
  }

  @action updateLeftMenuOptions(options) {
    if (typeof options !== 'object') {
      return;
    }
    if (_.isNumber(options.leftMenuHeaderGroup)) {
      this.leftMenuHeaderGroup = options.leftMenuHeaderGroup
    }
    if (!this.leftMenuOptions[this.leftMenuHeaderGroup]) {
      this.leftMenuOptions[this.leftMenuHeaderGroup] = {};
    }
    Object.assign(this.leftMenuOptions[this.leftMenuHeaderGroup], options);
  }

  @action updateLeftMenuHeaderGroup(leftMenuHeaderGroup) {
    this.leftMenuHeaderGroup = leftMenuHeaderGroup;
  }

  @action updateRightItemExpandId(id) {
    this.rightItemExpandId = id;
  }

  @computed get getRightItemExpandId() {
    return this.rightItemExpandId;
  }

  @action changeExpandId(sportId) {
    this.expandId = sportId;
  }

  @action changeExpandEsportId(code) {
    this.expandEsportCode = code;
  }

  @action update(data) {
    this.sportsMarketsData = data;
    this.setupTeasersMenuData()
  }

  @computed get getExpandId() {
    return this.expandId;
  }

  @computed get getExpandEsportId() {
    return this.expandEsportCode;
  }

  @action updateTotalGroups(totalGroups) {
    this.totalGroups = totalGroups;
  }

  @computed get getLeftMenuItem() {
    if (this.sportsMarketsData.sports) {
      let lstSports = [];
      let leftMenuItemList = this.sportsMarketsData.sports.reduce((leftMenuItem, sport) => {
        if (sport[SportItemMap.id] !== 100 && sport[SportItemMap.id] !== 200) {
          let tmp = {};
          const teaserCount = this.getTeaserCountFromGroups(sport[SportItemMap.id])
          tmp.sportId = sport[SportItemMap.id];
          tmp.sportName = sport[SportItemMap.name];
          tmp.markets = [
            { name: 'Live', marketId: Market.Live, numberEvents: sport[SportItemMap.liveEvents] },
            { name: 'Today', marketId: Market.Today, numberEvents: sport[SportItemMap.todayEvents] },
            { name: 'Early', marketId: Market.Early, numberEvents: sport[SportItemMap.earlyEvents] },
            { name: 'Specials', marketId: Market.Outright, numberEvents: sport[SportItemMap.outrightEvents] },
          ];

          if (teaserCount > 0) {
            tmp.markets.push({
              name: 'Teasers', marketId: Market.Teasers, numberEvents: teaserCount
            })
          }

          lstSports.push(sport[SportItemMap.id]);
          leftMenuItem.push(tmp);
        } 
        return leftMenuItem;
      }, []);
      
      this.generateOutrightSports(leftMenuItemList, lstSports);
      return leftMenuItemList;
    }
  }

  /**
   * Show outright sports as normal sports.
   */
  generateOutrightSports(leftMenuItem, lstSports) {
    const groups = this.sportsMarketsData.groups;
    if (groups) {
      const outrightGroups = groups['Outright'];
      if (outrightGroups) {
        _.forEach(outrightGroups.m, (sport, index) => {
          if (lstSports.indexOf(sport.i) === -1) {
            let tmp = {};
            tmp.sportId = sport.i;
            tmp.sportName = sport.n;
            tmp.markets = [
              { name: 'Live', marketId: Market.Live, numberEvents: 0 },
              { name: 'Today', marketId: Market.Today, numberEvents: 0 },
              { name: 'Early', marketId: Market.Early, numberEvents: 0 },
              { name: 'Specials', marketId: Market.Outright, numberEvents: sport.t },
            ];
            leftMenuItem.push(tmp);
          }
        });
      }
    }
  }

  /**
   * handle tournament data from service
   */
  @computed get getAsiaSpecialLeagues() {
    const { specialLeagues } = this.sportsMarketsData;
    let tournaments = [];
    _.forEach(specialLeagues, (item, index) => {
      tournaments.push({
        label: item[TournamentMap.label],
        firstMarket: item[TournamentMap.firstMarket],
        sportId: item[TournamentMap.sportId],
        firstMarketLeagues: item[TournamentMap.firstMarketLeagues],
        marketLeagues: item[TournamentMap.marketLeagues],
        date: item[TournamentMap.date],
        firstGameCode: item[TournamentMap.firstGameCode],
        gameCodeMap: item[TournamentMap.gameCodeMap]
      });
    })
    return tournaments;
  }

  /**
   * handle data of sports for left menu, filter bar
   */
  @computed get getAsiaLeftMenuItem() {
    if (this.sportsMarketsData.sports) {
      return this.sportsMarketsData.sports.reduce((leftMenuItem, sport) => {
        let liveSport = sport[SportMarketMap.live];
        let toDaySport = sport[SportMarketMap.today_soon];
        let earlySport = sport[SportMarketMap.early_pregame];
        let outputSport = {};
        outputSport.sportId = sport[SportMarketMap.id];
        outputSport.sportName = liveSport[SportItemMap.name]
        outputSport.group = liveSport[SportItemMap.group]
        outputSport.hasLiveEvents = false;

        if (liveSport && liveSport[SportItemMap.totalEvents] > 0) {
          outputSport.hasLiveEvents = true;
        }

        if (outputSport.sportId !== Constants.ESPORT_ID) {
          let totalEvents = this.getTotalEvents(toDaySport, SportItemMap) +
            this.getTotalEvents(earlySport, SportItemMap);
          outputSport.totalEvents = totalEvents;

          outputSport.commonMarkets = [
              { name: 'Live', marketId: Market.Live, numberEvents: liveSport[SportItemMap.totalEvents], sport: liveSport },
              { name: 'Today', marketId: Market.Today, numberEvents: toDaySport[SportItemMap.totalEvents], sport: toDaySport },
              { name: 'Early', marketId: Market.Early, numberEvents: earlySport[SportItemMap.totalEvents], sport: earlySport }
            ].filter(market => !(market.name === 'Live' && window.env.hideLiveTabEnabled));
          let betTypeGroups = {};
          betTypeGroups[Market.Live] = [];
          betTypeGroups[Market.Today] = [];
          betTypeGroups[Market.Early] = [];

          outputSport.betTypeGroups = betTypeGroups;

          let code = 'sp' + outputSport.sportId;
          this.getBetTypeGroup(outputSport, liveSport[SportItemMap.betTypeSummary], Market.Live, code);
          this.getBetTypeGroup(outputSport, toDaySport[SportItemMap.betTypeSummary], Market.Today, code);
          this.getBetTypeGroup(outputSport, earlySport[SportItemMap.betTypeSummary], Market.Early, code);

          this.getOthersBetTypeGroups(outputSport,
            code,
            liveSport,
            Market.Live,
            SportItemMap
          );
          this.getOthersBetTypeGroups(outputSport,
            code,
            toDaySport,
            Market.Today,
            SportItemMap
          );
          this.getOthersBetTypeGroups(outputSport,
            code,
            earlySport,
            Market.Early,
            SportItemMap
          );

        } else {
          outputSport.esportGames = this.getEsportsItem.esportGames;
          outputSport.totalEvents = outputSport.esportGames && outputSport.esportGames.length > 0 ? outputSport.esportGames[0].totalEvents : 0
        }
        if (outputSport.totalEvents > 0 || outputSport.esportGames) {
          leftMenuItem.push(outputSport);
        }

        return leftMenuItem;
      }, [])
    }
  }

  getOutrightNumbers = (sport, map) => {
    return sport[map.outrightEvents] +
      sport[map.correctScoreEvents] +
      sport[map.specialEvents] +
      sport[map.doubleChanceEvents];
  }

  getTotalEvents = (sport, map) => {
    return sport[map.totalEvents] + sport[map.outrightEvents]
  }

  /**
   * handle outright sports data for left menu
   */
  @computed get getOutrightSports() {
    const { groups } = this.sportsMarketsData;
    let outputSport = {};
    if (groups) {
      const outright = groups['outright'];
      outputSport.sportId = Constants.OUTRIGHT_ID;
      outputSport.sportName = 'Outright';
      outputSport.totalEvents = outright['t'];
      outputSport.outrightSports = [];
      _.forEach(outright['m'], sport => {
        outputSport.outrightSports.push({
          sportId: sport['i'],
          sportName: sport['n'],
          numberEvents: sport['t']
        });
      });
    }
    return outputSport;
  }

  /**
   * handle data esport for left menu
   */
  @computed get getEsportsItem() {
    const { esport } = this.sportsMarketsData;
    let esportGames = [];
    let liveAllGamesNumber = 0;
    let soonAllGamesNumber = 0;
    let preAllGamesNumber = 0;
    let betTypeGroupsAllGames = {};
    let liveGameAllBtgs = {};
    let soonGameAllBtgs = {};
    let preGameAllBtgs = {};
    let totalAllEsportGames = 0;
    let outputSport = {};
    outputSport.sportId = Constants.ESPORT_ID;
    let group;
    let totalOutrightAllGames = 0;
    _.forEach(esport, (item, index) => {
      let liveGame = item[SportMarketMap.live];
      let soonGame = item[SportMarketMap.today_soon];
      let preGame = item[SportMarketMap.early_pregame];


      let code = item[SportMarketMap.id];
      let sportName;
      sportName = liveGame[ESportItemMap.name]
      group = liveGame[ESportItemMap.group]

      let hasLiveEvents = false;
      if (liveGame && liveGame[ESportItemMap.totalEvents] > 0) {
        hasLiveEvents = true;
      }
      let liveEsportEvents = this.getTotalEvents(liveGame, ESportItemMap);
      let soonEsportEvents = this.getTotalEvents(soonGame, ESportItemMap);
      let preGameEsportGames = this.getTotalEvents(preGame, ESportItemMap);

      let outrightNumbers = this.getOutrightNumbers(liveGame, ESportItemMap) +
        this.getOutrightNumbers(soonGame, ESportItemMap) +
        this.getOutrightNumbers(preGame, ESportItemMap);
      let totalEsportEvents = soonEsportEvents + preGameEsportGames;

      totalAllEsportGames += totalEsportEvents;
      totalOutrightAllGames += outrightNumbers;
      liveAllGamesNumber += liveEsportEvents;
      soonAllGamesNumber += soonEsportEvents;
      preAllGamesNumber += preGameEsportGames;

      let betTypeGroups = {};
      betTypeGroups[EsportMarket.Live] = [];
      betTypeGroups[EsportMarket.Soon] = [];
      betTypeGroups[EsportMarket.PreGame] = [];
      let eCommonMarkets = [
        { name: 'Live', marketId: EsportMarket.Live, numberEvents: liveGame[ESportItemMap.totalEvents] },
        { name: 'Soon', marketId: EsportMarket.Soon, numberEvents: soonGame[ESportItemMap.totalEvents] },
        { name: 'Pre-Game', marketId: EsportMarket.PreGame, numberEvents: preGame[ESportItemMap.totalEvents] }
      ].filter(market => !(market.name === 'Live' && window.env.hideLiveTabEnabled));
      let outputSportGame = {
        sportId: Constants.ESPORT_ID,
        group: group,
        sportName: sportName,
        code: code,
        hasLiveEvents: hasLiveEvents,
        totalEvents: totalEsportEvents,
        commonMarkets: eCommonMarkets,
        betTypeGroups: betTypeGroups,
        outrightNumbers: outrightNumbers
      };

      this.getBetTypeGroup(outputSportGame, liveGame[ESportItemMap.betTypeSummary], EsportMarket.Live, code);
      this.getBetTypeGroup(outputSportGame, soonGame[ESportItemMap.betTypeSummary], EsportMarket.Soon, code);
      this.getBetTypeGroup(outputSportGame, preGame[ESportItemMap.betTypeSummary], EsportMarket.PreGame, code);

      this.getOthersBetTypeGroups(outputSportGame,
        liveGame[ESportItemMap.code],
        liveGame,
        EsportMarket.Live,
        ESportItemMap);

      this.getOthersBetTypeGroups(outputSportGame,
        soonGame[ESportItemMap.code],
        soonGame,
        EsportMarket.Soon,
        ESportItemMap
      );

      this.getOthersBetTypeGroups(outputSportGame,
        preGame[ESportItemMap.code],
        preGame,
        EsportMarket.PreGame,
        ESportItemMap);

      this.getBetTypeGroupAllGames(liveGameAllBtgs, outputSportGame, EsportMarket.Live);
      this.getBetTypeGroupAllGames(soonGameAllBtgs, outputSportGame, EsportMarket.Soon);
      this.getBetTypeGroupAllGames(preGameAllBtgs, outputSportGame, EsportMarket.PreGame);
      esportGames.push(outputSportGame);
    })

    // sorting all bet type groups in all games
    betTypeGroupsAllGames[EsportMarket.Live] = _.orderBy(_.toArray(liveGameAllBtgs), ['period', 'betTypeGroup'], ['asc']);
    betTypeGroupsAllGames[EsportMarket.Soon] = _.orderBy(_.toArray(soonGameAllBtgs), ['period', 'betTypeGroup'], ['asc']);
    betTypeGroupsAllGames[EsportMarket.PreGame] = _.orderBy(_.toArray(preGameAllBtgs), ['period', 'betTypeGroup'], ['asc']);

    let commonMarkets = [{ name: 'Live', marketId: EsportMarket.Live, numberEvents: liveAllGamesNumber },
    { name: 'Soon', marketId: EsportMarket.Soon, numberEvents: soonAllGamesNumber },
    { name: 'Pre-Game', marketId: EsportMarket.PreGame, numberEvents: preAllGamesNumber }];

    let marketAllGames = {
      sportName: 'All Games',
      group: group,
      code: '',
      totalEvents: totalAllEsportGames,
      commonMarkets: commonMarkets,
      betTypeGroups: betTypeGroupsAllGames,
      outrightNumbers: totalOutrightAllGames
    }
    esportGames.splice(0, 0, marketAllGames);
    outputSport.esportGames = esportGames;
    return outputSport;
  }

  getEsportBetTypeGroupKey = (sportId, market, betTypeGroup, period) => {
    if (sportId === Constants.ESPORT_ID) {
      return LeftMenuAction.generateEsportBetTypeGroupKey(market, betTypeGroup, period)
    }
  }

  getBetTypeGroup = (outputSport, betTypeSummary, market, code) => {
    if (!betTypeSummary) {
      return;
    }
    _.forEach(betTypeSummary, (bt, index) => {
      const betTypeGroupId = BetTypeGroup[bt[BetTypeSummaryMap.group]];
      const isHideTennisML =  outputSport.sportId === Constants.TENNIS_ID && window.env.isHideTennisMLMarket;
      let period = 0;
      let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
        code ? code : "sp" + outputSport.sportId,
        market,
        betTypeGroupId,
        period
      );
      let btg = {
        id: id,
        code: code,
        name: bt[BetTypeSummaryMap.group],
        betTypeGroup: betTypeGroupId,
        numberEvents: bt[BetTypeSummaryMap.totalEvents],
        marketId: market,
        period: period,
        gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, betTypeGroupId, 0),
        localTranslate: (_.invert(SportGroup)[outputSport.group]).toLocaleLowerCase()
      };
      if(!(betTypeGroupId === BetTypeGroup.ML_1X2 && isHideTennisML)){
        outputSport.betTypeGroups[market].push(btg);
      }
    })
  }

  getBetTypeGroupAllGames = (betTypeGroupsAllGames, outputSportGame, market) => {
    _.forEach(outputSportGame.betTypeGroups[market], value => {
      if (!betTypeGroupsAllGames[value.gameBTGroupId]) {
        let btg = _.assign({}, value);
        let idArr = btg.id.split('|');
        if (idArr) {
          idArr[1] = '';//set code = ''
          btg.id = idArr.join('|');
        }
        btg.code = '';
        betTypeGroupsAllGames[value.gameBTGroupId] = btg;
      } else {
        let btg = betTypeGroupsAllGames[value.gameBTGroupId];
        btg.numberEvents += value.numberEvents;
        betTypeGroupsAllGames[value.gameBTGroupId] = btg;
      }
    })
  }

  getOthersBetTypeGroups = (outputSport, code, sport, market, map) => {
    const parlayEvents = sport[map.parlayEvents];
    const eEventsPeriods = sport[map.directPeriodsFolders];
    const outrightEvents = sport[map.outrightEvents];
    const correctScoreEvents = sport[map.correctScoreEvents];
    const specialEvents = sport[map.specialEvents];
    const doubleChanceEvents = sport[map.doubleChanceEvents];
    const teaserCount = this.getTeaserCountFromGroups(sport[SportItemMap.id])
    let btg;
    let period = 0;
    if (parlayEvents > 0) {
      let btgId = BetTypeGroup.MIX_PARLAY;
      let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
        code ? code : "sp" + outputSport.sportId,
        market,
        btgId,
        period
      );

      btg = {
        id: id,
        name: 'Parlay',
        betTypeGroup: btgId,
        code: code,
        numberEvents: parlayEvents,
        marketId: market,
        period: period,
        gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, btgId, 0)
      };
      outputSport.betTypeGroups[market].push(btg);
    }
    if (teaserCount > 0 &&  market === Market.Early) {
      let btgId = BetTypeGroup.TEASERS;
      let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
        code ? code : "sp" + outputSport.sportId,
        market,
        btgId,
        period
      );
      btg = {
        id: id,
        name: 'Teasers',
        betTypeGroup: btgId,
        code: code,
        numberEvents: teaserCount,
        marketId: market,
        period: period,
        gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, btgId, 0)
      };
      outputSport.betTypeGroups[market].push(btg);
    }
    if (outrightEvents > 0) {
      let btgId = BetTypeGroup.OUTRIGHT;
      let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
        code ? code : "sp" + outputSport.sportId,
        market,
        btgId,
        period
      );
      btg = {
        id: id,
        name: 'OUTRIGHT',
        betTypeGroup: btgId,
        code: code,
        numberEvents: outrightEvents,
        marketId: market,
        period: period,
        type: OUTRIGHT_TYPE.OUTRIGHT,
        gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, btgId, 0)
      };
      outputSport.betTypeGroups[market].push(btg);
    }
    if (correctScoreEvents > 0) {
      let btgId = BetTypeGroup.CORRECT_SCORE;
      let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
        code ? code : "sp" + outputSport.sportId,
        market,
        btgId,
        period
      );
      btg = {
        id: id,
        name: 'CORRECT_SCORE',
        betTypeGroup: btgId,
        code: code,
        numberEvents: correctScoreEvents,
        marketId: market,
        period: period,
        type: OUTRIGHT_TYPE.CORRECT_SCORE,
        gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, btgId, 0)
      };
      outputSport.betTypeGroups[market].push(btg);
    }
    if (specialEvents > 0) {
      let btgId = BetTypeGroup.SPECIAL;
      let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
        code ? code : "sp" + outputSport.sportId,
        market,
        btgId,
        period
      );
      btg = {
        id: id,
        name: 'Specials',
        betTypeGroup: btgId,
        code: code,
        numberEvents: specialEvents,
        marketId: market,
        period: period,
        type: OUTRIGHT_TYPE.SPECIAL,
        gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, btgId, 0)
      };
      outputSport.betTypeGroups[market].push(btg);
    }
    // Double Chance
    if (doubleChanceEvents > 0) {
      let btgId = BetTypeGroup.DOUBLE_CHANCE;
      let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
        code ? code : "sp" + outputSport.sportId,
        market,
        btgId,
        period
      );
      btg = {
        id: id,
        name: 'DOUBLE_CHANCE',
        betTypeGroup: btgId,
        code: code,
        numberEvents: doubleChanceEvents,
        marketId: market,
        period: period,
        type: OUTRIGHT_TYPE.DOUBLE_CHANCE,
        gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, btgId, 0)
      };
      outputSport.betTypeGroups[market].push(btg);
    }
    if (eEventsPeriods) {
      for (let i = 0; i < eEventsPeriods.length; i++) {
        let period = eEventsPeriods[i][0];
        if (period !== 0) {
          let numberEvents = eEventsPeriods[i][1];
          this.getPeriodBetypeGroup(outputSport, code, market, period, numberEvents);
        }
      }
    }
  }

  getPeriodBetypeGroup = (outputSport, code, market, period, numberEvents) => {
    let btgId = BetTypeGroup.HDP_OU;
    let id = LeftMenuAction.generateLeftMenuItemKey(outputSport.sportId,
      code ? code : "sp" + outputSport.sportId,
      market,
      btgId,
      period
    );
    let name = outputSport.sportId + '_' + period;
    let btg = {
      id: id,
      name: name,
      betTypeGroup: btgId,
      code: code,
      numberEvents: numberEvents,
      marketId: market,
      period: period,
      gameBTGroupId: this.getEsportBetTypeGroupKey(outputSport.sportId, market, btgId, period),
      localTranslate: 'periods'
    };
    outputSport.betTypeGroups[market].push(btg);
  }

  getCurrentSportMenuItems = (sportId) => {
    const items = [];
    const spId = parseInt(sportId)
    const { sports } = this.sportsMarketsData
    if (!sports || sports.length === 0) {
      return items
    }

    const tmp = sports.filter(f => f[0] == spId)
    if (tmp && tmp.length > 0) {
      const sport = tmp[0]
      const teaserCount = this.getTeaserCountFromGroups(spId)

      if (sport[SportItemMap.liveEvents] > 0) {
        items.push({ name: 'Live', marketId: Market.Live, numberEvents: sport[SportItemMap.liveEvents] })
      }

      if (sport[SportItemMap.todayEvents] > 0) {
        items.push({ name: 'Today', marketId: Market.Today, numberEvents: sport[SportItemMap.todayEvents] })
      }

      if (sport[SportItemMap.earlyEvents] > 0) {
        items.push({ name: 'Early', marketId: Market.Early, numberEvents: sport[SportItemMap.earlyEvents] })
      }

      if (sport[SportItemMap.outrightEvents] > 0) {
        items.push({ name: 'Specials', marketId: Market.Outright, numberEvents: sport[SportItemMap.outrightEvents] })
      }

      if (teaserCount > 0) {
        items.push({ name: 'Teasers', marketId: Market.Teasers, numberEvents: teaserCount })
      }
    }

    return items
  }

  getOutrightFromGroups(sportId) {
    const groups = this.sportsMarketsData.groups;
    if (groups) {
      const outrightGroups = groups['Outright'];
      if (outrightGroups) {
        const numberEvents = outrightGroups.m.reduce(function (event, outright) {
          if (outright.i === sportId) {
            return event + outright.t;
          }
          return event;
        }, 0)
        return numberEvents;
      }
    }
  }

  getTeaserCountFromGroups(sportId) {
    const groups = this.sportsMarketsData.groups;
    let teaserCount = 0
    if (groups) {
      const teaserGroups = groups && (groups['Teasers']||groups['teasers']);
      if (teaserGroups) {
        const teaser = _.find(teaserGroups.m, sp => sp.i === sportId)
        if (teaser) {
          teaserCount = teaser.t
        }
      }
    }

    return teaserCount
  }

  getLeftMenuHeaderGroupDefault = (supportProduct) => {
    switch (supportProduct) {
      case Constants.SUPPORT_PRODUCT_ONLY.SPORTS:
        return LeftMenuHeaderGroup.SPORTS;
      case Constants.SUPPORT_PRODUCT_ONLY.ESPORTS:
        return LeftMenuHeaderGroup.ESPORTS;
      default: return LeftMenuHeaderGroup.SPORTS;
    }
  }

  setupTeasersMenuData = () => {
    const groups = this.sportsMarketsData.groups
    let sportMarkets = [];
    let teaserGroups = groups && ( groups['Teasers']||groups['teasers'] );
    if (teaserGroups) {
      sportMarkets = _.map(teaserGroups.m, teaserSp => {
        return { sportId: teaserSp.i, sportName: teaserSp.n, numberEvents: teaserSp.t }
      })
    }

    this.teasersData.items = sportMarkets
  }

  @action updateCurrentSideBar(sideBar) {
    if (this.currentSideBar !== sideBar) {
      this.currentSideBar = sideBar;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/SportsMenuStore.js